<template>     
      <ob-modal2 :show.sync="show">
            <template slot="modal-title"> One Time Password (OTP) Verification </template>
            <template slot="modal-body">
                  <p style="padding:0px 10px 0px 10px;">Please enter the One Time Password (OTP) sent to your phone number ending with <span v-if="PhoneNo"><b>{{PhoneNo.replace(/.(?=.{4})/g, '*')}}</b></span> to verify the ESS portal corresponding to <span v-if="OrgName"><b>{{this.OrgName}}</b></span><span v-else><b>N/A</b></span>. You can use the existing credentials to log in to your ESS.</p><br>
                  <div class="row" style="padding-bottom:8px;">
                        <div class="col-md-4" style="padding-left:25px;">
                              <p style="padding-bottom:6px;">One Time Password<span class="star-red">*</span></p>
                              <input @keyup.enter='verify' type="password" v-number-only v-model="otp" class="input_otp" style="padding-bottom:6px;margin-bottom: 5px;" :class="{ 'ob-vuelidate_input-error': $v.otp.$error }" />
                              <span class="ob-vuelidate_error-msg"  v-if="$v.otp.$dirty && !$v.otp.required">Please enter your OTP</span>
                              <span class="ob-vuelidate_error-msg"  v-if="$v.otp.$dirty && !$v.otp.minLength">Please enter valid OTP</span>
                              <span class="ob-vuelidate_error-msg"  v-if="$v.otp.$dirty && !$v.otp.maxLength">Please enter valid OTP</span>
                        </div>
                        <div class="col-md-4" style="padding-top:14px;"> 
                              <br>
                              <a style="color:#4A90E2;cursor:pointer;display:inline;" @click="resendOtp">Resend OTP</a>
                        </div>
                  </div>
                              <p style="color:#d60000;padding-left:10px;" v-if="error">{{this.error}}</p>
                              <p style="color:#d60000;padding-left:10px;" v-if="verifyOtp">{{this.verifyOtp}}</p>
                              <p style="color:#52d76a;padding-left:10px;" v-if="success">{{this.success}}</p>
                              <!-- <p style="color:#52d76a;padding-left:10px;" v-if="otpMsg">{{this.otpMsg}}</p> -->
                              <i style="padding-left:10px;">OTP is valid for 30 minutes.</i>
            </template>
            <template slot="modal-footer">
                  <ob-button type="secondary" @click="cancel">Cancel</ob-button>
                  <ob-button @click="verify">Verify</ob-button>
            </template>
      </ob-modal2>
</template>
<script>
import jquery from 'jquery'
import {required, minLength, maxLength} from "vuelidate/lib/validators";
export default{  
      props:["openModal", "EmployeeId", "PhoneNo", "OrgName"],  
      data(){
            return{
                  show:false,
                  otp:'',
                  error:'',
                  verifyOtp:'',
                  success:'',
                 //otpMsg:''
            }

      },
      validations(){
            return{
                  "otp":{
                  required,  
                  minLength: minLength(6),
                  maxLength: maxLength(6)
                  }
            }
      }, 
      created(){
            this.$v.otp.$reset();
           // this.otpMsg = this.OtpMsg
      },   
      watch:{
            openModal(val) {
                 this.show = val;
                // if(!val)
                 //this.otpMsg = ""
            },
            show(val) {
                  //this.otpMsg = this.OtpMsg
                  this.$emit('update:openModal', val)
            }
      },  
      methods:{
            clear(){
                  this.otp = ""
                  this.$v.otp.$reset();
                  this.verifyOtp = ""
                  this.error = ""
                  this.success = ""
                  //this.otpMsg=""
            },
            cancel(){
                  this.clear()
                  this.show =false;
            },
            clearMsgs(){
                 // this.otpMsg = ""
                  this.verifyOtp=""
                  this.success = ""
                  this.error = ""
            },
            verify(){
                  this.$v.otp.$touch();
                  this.clearMsgs();
                  if (this.$v.otp.$invalid == false) {
                        this.$loading({ 'loadingText': 'Loading...' })
                        ajax.get(`/Employee/ValidateOtpForEssLogin?empId=${this.EmployeeId}&otp=${this.otp}&isPostLogin=true`, {}, (res) => {
                              this.$loading({}).close() 
                              if (res.data == true) {
                                    events.fire("verificationSuccess")
                                    this.$router.push({'name':'SelectOrganization'})
                                    this.$message({
                                          type: "success",
                                          message: "OTP Verification Success."
                                    });
                                    this.show =false;
                                    this.clear()                                 
                              }
                              else{
                                    this.ESSEnableDisable(res)
                                    this.verifyOtp = "OTP verification failed"
                                    this.success = ""
                                    this.error = ""
                                    this.$v.otp.$reset();
                              }
                               
                              
                        })
                  }
            },
            resendOtp(){
                  this.clearMsgs();
                  this.$loading({ 'loadingText': 'Loading...' })
                  ajax.get(`Employee/${this.EmployeeId}/SendOTPToEmployee`, {}, (res) => {
                        this.$loading({}).close()	
                        if (res.data.State == true) {
                              this.success = "OTP Resent!"
                              this.verifyOtp = ""
                              this.error = ""
                              this.$v.otp.$reset();
                              setTimeout(() => {
                                    this.success = ""
                                    },6000)
                              
                        }
                        else{
                              this.ESSEnableDisable(res)
                              this.error =  "Resent OTP Failed"
                              this.success = ""
                              this.verifyOtp = ""
                              this.$v.otp.$reset();
                        }																	
                  })     
            }
      }
    
}
</script>
<style lang="scss" scoped>
  .star-red {
    color: #d60000;
  }
  .input_otp{
      display: block;
      width: 100%;
      height: 31px;
      padding: 6px 12px;
      font-size: 12px;
      line-height: 1.42857;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      box-shadow: none;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/verifyPhonePopup.vue